// Nav Menu Hover & Active
(function() {
    document.addEventListener("DOMContentLoaded", function() {
        var menuItems = document.querySelectorAll('.menu-item');

        menuItems.forEach(function(item) {
            // 마우스 오버
            item.addEventListener('mouseenter', function() {
                item.classList.remove('menu-item');
                item.classList.add('menu-item--hover');
            });

            // 마우스 아웃
            item.addEventListener('mouseleave', function() {
                item.classList.remove('menu-item--hover');
                item.classList.add('menu-item');
            });
        });

        // 현재 페이지 active 표시
        var currentPath = window.location.pathname;
        var allMenuLinks = document.querySelectorAll('.menu-container a');

        allMenuLinks.forEach(function(link) {
            var href = link.getAttribute('href');
            if (href === currentPath) {
                link.classList.remove('menu-item', 'menu-item--hover');
                link.classList.add('menu-item--active');
            }
        });

        // 모바일 메뉴 토글
        var menuIcon = document.querySelector('.nav-wrapper .menu-icon');
        var mobileMenu = document.querySelector('.menu-container-m');
        var closeIcon = document.querySelector('.menu-header .svg-box');
        var mobileMenuItems = document.querySelectorAll('.gnb-item');
        var menuOverlay = document.querySelector('.menu-overlay');

        function openMenu() {
            menuIcon.classList.add('active');
            mobileMenu.classList.add('active');
            if (menuOverlay) menuOverlay.classList.add('active');
            document.body.style.overflow = 'hidden';
        }

        function closeMenu() {
            menuIcon.classList.remove('active');
            mobileMenu.classList.remove('active');
            if (menuOverlay) menuOverlay.classList.remove('active');
            document.body.style.overflow = '';
        }

        if (menuIcon && mobileMenu) {
            menuIcon.addEventListener('click', openMenu);

            if (closeIcon) {
                closeIcon.addEventListener('click', function(e) {
                    e.preventDefault();
                    closeMenu();
                });
            }

            mobileMenuItems.forEach(function(item) {
                item.addEventListener('click', closeMenu);
            });

            if (menuOverlay) {
                menuOverlay.addEventListener('click', closeMenu);
            }
        }
    });
})();
